<template src="./template.html"></template>

<script>
import jointMasterApi from '@/api/jointMaster'
import jointApi from '@/api/joint'
import kilopostApi from '@/api/kilopost'
import kilopostMixin from '@/mixin/kilopostMixin'
import streamMixin from '@/mixin/streamMixin'
import Stream from '@/lib/Stream'
import * as EVT from '@/consts/eventNames'

export default {
  name: 'joint-touroku',
  data() {
    return {
      // data
      // child group1
      allJoints: [],
      jointMap: {},
      filteredJoints: [], // for jointList
      displayedJoints: [], // for ExtremeMap
      focusAreaGeom: null,
      // child group2
      jointMasters: [],

      // kps
      kilopostsByRoadNameShort: {},
      displayedKiloposts: [], // for ExtremeMap

      // stream
      // child group1
      jointListStream: new Stream({ name: 'jointList', debug: false }),
      extremeMapStream: new Stream({ name: 'extremeMap', debug: false }),
      listWrapStream: new Stream({ name: 'listWrap', debug: false }),
      // child group2
      jointMasterListStream: new Stream({ name: 'jointMasterList', debug: false }),
      // me
      mainStream: new Stream({ name: 'main', debug: false }),

      // alert
      alert: {
        msg: '更新しました',
        variant: 'info',
        countDown: 0,
      },

      // SET_FOCUS_AREAを受け取った後に実行するやつ
      postSetFocusAreaFunc: null,

      confirmAttachChangeModalInfo: null,
      confirmDetachModalInfo: null,
    }
  },
  mounted() {
    const usedJointGroupKeyMap = {}
    const p1 = jointApi.index().then(({ data }) => {
      this.allJoints = data
      this.filteredJoints = this.allJoints
      this.jointMap = {}
      for (const e of this.allJoints) {
        e.line = JSON.parse(e.line)

        this.jointMap[e.id] = e
        if (e.joint_number) {
          usedJointGroupKeyMap[e.joint_number] = e.id
        }
      }
      // 全体だと地図が重いので.
      this.onSetFocusArea({ geom: this.focusAreaGeom })
    })
    const p2 = jointMasterApi.index()
    Promise.all([p1, p2]).then(([r1, r2]) => {
      const jointMasters = r2.data
      for (const jm of jointMasters) {
        const jointId = usedJointGroupKeyMap[jm.joint_group_key]
        jm.is_attached = !!jointId
        jm.attached_joint_id = jointId
      }
      this.jointMasters = jointMasters
    })

    kilopostApi.index().then(({ data }) => {
      this.kilopostsByRoadNameShort = this.convKiloposts(data)
    })

    this.chainEvents()
    this.setListeners()
  },
  mixins: [streamMixin, kilopostMixin],
  methods: {
    chainEvents() {
      const extremeMap = this.extremeMapStream
      const jointList = this.jointListStream
      const listWrap = this.listWrapStream
      const jointMasterList = this.jointMasterListStream
      const main = this.mainStream

      jointList.chain([EVT.SELECT_JOINTS, EVT.UNSELECT_JOINTS])
        .to(extremeMap).end()
      extremeMap.chain([EVT.SELECT_JOINTS, EVT.UNSELECT_JOINTS])
        .to(jointList).end()
      listWrap.drain(
        [EVT.SELECT_JOINTS, EVT.UNSELECT_JOINTS],
        [jointList, extremeMap],
        {
          mapper: obj => {
            const joints = obj.ids.map(id => this.jointMap[id])
            return { joints }
          }
        }
      ).to(jointMasterList).end()

      listWrap.drain(EVT.CHANGE_JOINTS, jointList)
        .to(main).end()
      listWrap.drain([EVT.SET_FOCUS_AREA, EVT.UNSET_FOCUS_AREA], extremeMap)
        .to(main).end()

      jointMasterList.chain([
        EVT.SELECT_JOINT_MASTERS,
        EVT.UNSELECT_JOINT_MASTERS,
        EVT.CHANGE_ROAD_NAME,
      ]).to(main).end()

      main.chain(EVT.UPDATED_JOINT_MASTERS).to(jointMasterList).end()

      main.connectOutOut(EVT.UPDATED_JOINTS, listWrap)
      listWrap.spread(EVT.UPDATED_JOINTS, [extremeMap, jointList])

      main.connectOutOut(EVT.SELECT_JOINTS_REV, listWrap)
      listWrap.spread(EVT.SELECT_JOINTS_REV,
        [extremeMap, jointList],
        {
          mapper: obj => {
            const ids = obj.jointMasters.map(e => e.attached_joint_id)
            return { ids }
          },
          outEventNames: [EVT.SELECT_JOINTS]
        }
      )
      main.chain(EVT.SET_ROAD_NAME).to(listWrap).to(extremeMap).end()
    },
    setListeners() {
      this.mainStream.recv(EVT.SELECT_JOINT_MASTERS,
        (obj) => {
          if (!obj.joints || obj.joints.length === 0) {
            // ジョイントが選択されてない状態でマスタが選択された場合は
            // ジョイントが選択されたのと同じ状態にする.

            // 路線名を合わせる
            let roadName = obj.jointMasters[0].road_name
            roadName = roadName.replace('高速', '')
            this.mainStream.send(EVT.SET_ROAD_NAME, { roadName })

            // 地図のエリアごと切り替わる場合はまだ選択すべき点が
            // 表示されてないので実行を後に回すために一旦関数につっこむ
            this.postSetFocusAreaFunc = () => {
              this.mainStream.send(EVT.SELECT_JOINTS_REV, obj)

              const ids = obj.jointMasters.map(e => e.attached_joint_id)
              const joints = ids.map(id => this.jointMap[id])
              this.jointMasterListStream.emitRecv(EVT.SELECT_JOINTS, { joints })
            }
            // 路線名が同じ場合は呼ばれないので、自分で一旦呼んどく
            this.postSetFocusAreaFunc()
          } else {
            this.confirmAttachJointsWithJointMasters(obj)
          }
        })
      this.mainStream.recv(EVT.UNSELECT_JOINT_MASTERS,
        (obj) => { this.confirmDetachJointsFromJointMasters(obj) })
      this.mainStream.recv(EVT.CHANGE_JOINTS,
        (obj) => { this.onChangeJoints(obj) })
      this.mainStream.recv(EVT.CHANGE_ROAD_NAME,
        (obj) => { this.onChangeRoadName(obj) })
      this.mainStream.recv(EVT.SET_FOCUS_AREA,
        (obj) => { this.onSetFocusArea(obj) })
      this.mainStream.recv(EVT.UNSET_FOCUS_AREA,
        (obj) => { this.onUnsetFocusArea(obj) })
    },
    onChangeJoints({ joints }) {
      this.displayedJoints = joints
    },
    onChangeRoadName({ roadName }) {
      const map = this.getRoadNameToRoadNameShortMap()
      const roadNameShort = map[roadName]
      if (!roadNameShort) {
        console.error(`roadName=${roadName} not found in map`)
        return
      }
      this.displayedKiloposts = this.kilopostsByRoadNameShort[roadNameShort]
    },
    confirmAttachJointsWithJointMasters(obj) {
      if (obj.oldJointMasters && obj.oldJointMasters.length > 0) {
        this.confirmAttachChangeModalInfo = obj
      } else {
        this.attachJointsWithJointMasters(obj)
      }
    },
    attachJointsWithJointMasters(obj) {
      const { joints, jointMasters, oldJointMasters = [] } =
        obj || this.confirmAttachChangeModalInfo
      // joint_master側にもなんか入れられるようになっているが、
      // それは最後にバッチでやろう.
      // jointだけ更新する.
      const val = jointMasters[0].joint_group_key
      for (const joint of joints) {
        joint.joint_number = val
        joint.skipUsernameUpdate = true
        jointApi.updateJointNumber(joint.id, joint).then(() => {
          oldJointMasters.forEach(e => {
            e.is_attached = false
            e.attached_joint_id = null
          })
          jointMasters.forEach(e => {
            e.is_attached = true
            e.attached_joint_id = joint.id
          })
          this.mainStream.send(EVT.UPDATED_JOINTS, { joints })
          this.mainStream.send(EVT.UPDATED_JOINT_MASTERS,
            { jointMasters: jointMasters.concat(oldJointMasters) })
          this.confirmAttachChangeModalInfo = null
          this.showUpdateCompleteAlert({
            msg: '紐付けました',
            variant: 'info',
          })
        })
      }
    },
    confirmDetachJointsFromJointMasters(obj) {
      this.confirmDetachModalInfo = obj
    },
    detachJointsFromJointMasters() {
      const { joints, jointMasters } = this.confirmDetachModalInfo
      for (const joint of joints) {
        joint.joint_number = ''
        joint.skipUsernameUpdate = true
        jointApi.updateJointNumber(joint.id, joint).then(() => {
          jointMasters.forEach(e => {
            e.is_attached = false
            e.attached_joint_id = null
          })
          this.mainStream.send(EVT.UPDATED_JOINTS, { joints })
          this.mainStream.send(EVT.UPDATED_JOINT_MASTERS, { jointMasters })
          this.confirmDetachModalInfo = null
          this.showUpdateCompleteAlert({
            msg: '紐付けを解除しました',
            variant: 'warning',
          })
        })
      }
    },
    showUpdateCompleteAlert({ msg, variant }) {
      this.alert.msg = msg
      this.alert.variant = variant
      this.alert.countDown = 1
    },
    onSetFocusArea({ geom }) {
      if (!geom) { return }
      this.focusAreaGeom = geom
      const filteredJoints = []
      for (const joint of this.allJoints) {
        const coords = joint.line.coordinates
        if (
          geom.intersectsCoordinate(coords[0]) ||
          geom.intersectsCoordinate(coords[1])
        ) {
          filteredJoints.push(joint)
        }
      }
      this.filteredJoints = filteredJoints

      if (this.postSetFocusAreaFunc) {
        this.postSetFocusAreaFunc()
        this.postSetFocusAreaFunc = null
      }
    },
  }
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
